import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const fade = {
  initial: { opacity: 0, y: 14 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
  transition: { duration: 1.1, ease: [0.16, 1, 0.3, 1] },
};

export const Reveal = ({ settings, guestName, onOpen }) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const timers = [setTimeout(() => setStep(1), 2400), setTimeout(() => setStep(2), 5200)];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center px-6"
      style={{ backgroundColor: "var(--paper)" }}
      exit={{ opacity: 0, y: "-4%", transition: { duration: 1.2, ease: [0.16, 1, 0.3, 1] } }}
      data-testid="reveal-overlay"
    >
      <div className="paper-texture absolute inset-0" />
      <div className="relative text-center max-w-sm w-full">
        <AnimatePresence mode="wait">
          {step === 0 && (
            <motion.div key="s0" {...fade}>
              {guestName && (
                <p className="font-script text-3xl mb-6" style={{ color: "var(--ink-soft)" }}>
                  {guestName}
                </p>
              )}
              <p className="label-caps text-sm sm:text-base" style={{ color: "var(--ink)" }}>
                Ni är inbjudna
              </p>
              <div className="hairline w-20 mx-auto mt-8" />
            </motion.div>
          )}
          {step === 1 && (
            <motion.div key="s1" {...fade}>
              <h1 className="font-script script-display text-6xl sm:text-7xl leading-tight" style={{ color: "var(--ink)" }}>
                {settings?.couple_name_1 || "Rafid"}
              </h1>
              <p className="font-serif-d italic text-2xl my-2" style={{ color: "var(--gold)" }}>
                &amp;
              </p>
              <h1 className="font-script script-display text-6xl sm:text-7xl leading-tight" style={{ color: "var(--ink)" }}>
                {settings?.couple_name_2 || "Sarah"}
              </h1>
              <p className="label-caps text-xs mt-8" style={{ color: "var(--ink-soft)" }}>
                Till vårt bröllop
              </p>
            </motion.div>
          )}
          {step === 2 && (
            <motion.div key="s2" {...fade}>
              <p className="font-script text-5xl sm:text-6xl" style={{ color: "var(--ink)" }}>
                {settings?.couple_name_1} &amp; {settings?.couple_name_2}
              </p>
              <div className="hairline w-24 mx-auto my-7" />
              <p className="label-caps text-xs sm:text-sm" style={{ color: "var(--ink)" }}>
                {settings?.wedding_date}
              </p>
              <p className="label-caps text-xs mt-2" style={{ color: "var(--ink-soft)" }}>
                {settings?.venue_name}
              </p>
              <motion.button
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.4, duration: 1 }}
                className="btn-invite mt-12"
                onClick={onOpen}
                data-testid="open-invitation-btn"
              >
                Öppna inbjudan
              </motion.button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
};
